'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';
import { systemAPI } from '../services/api'; // Adjust import based on your API client structure

const SystemSettingsContext = createContext(null);

export const SystemSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        const response = await systemAPI.getSystemSettings();
        setSettings(response);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching system settings:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []); // Empty dependency array means this runs once on mount

  return (
    <SystemSettingsContext.Provider value={{ settings, loading, error }}>
      {children}
    </SystemSettingsContext.Provider>
  );
};

export const useSystemSettings = () => {
  const context = useContext(SystemSettingsContext);
  if (!context) {
    throw new Error('useSystemSettings must be used within a SystemSettingsProvider');
  }
  return context;
};